/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )(-
 *              _/           |
 */

export const form = {
  'benefit-option': null,
  'premium-updates': null,
  'joint-life': null,
  'main-life-only': null,
  'joint-life-variant': null,
  'funeral-cover-for-main-life': 'N',
  'standalone-options': {
    'death-sum-assured': null,
    'total-personal-disability-sum-assured': null,
    'illness-sum-assured': null,
    'standalone-term': null,
  },
  'accelerated-options': {
    'death-and-total-personal-disability': 'N',
    'death-and-critical-illness': 'N',
    'death-and-total-disability-and-critical-illness': 'N',
    'total-personal-disability-and-critical-illness': 'N',
    'accelerated-sum-assured': null,
    'accelerated-term': null,
  },
  'hospitalisation-units': null,
  'transition-plan': null,
  'personal-accident': null,
  'educational-support-benefit': {
    'educational-support-benefit': null,
    'educational-support-term': null,
  },
  'long-term-savings': {
    'long-term-savings-premium': null,
    'savings-term': null,
  },
  'funeral-cover-options': {
    'ghs-5000': 'N',
    'ghs-7500': 'N',
    'ghs-10000': 'N',
    'ghs-15000': 'N',
    'ghs-20000': 'N',
    'ghs-25000': 'N',
    'ghs-30000': 'N',
    'ghs-40000': 'N',
    'ghs-50000': 'N',
    'ghs-60000': 'N',
    'ghs-70000': 'N',
    'ghs-80000': 'N',
    'ghs-90000': 'N',
    'ghs-100000': 'N',
    'ghs-120000': 'N',
    'ghs-140000': 'N',
    'ghs-160000': 'N',
    'ghs-180000': 'N',
    'ghs-200000': 'N',
    'term-ten': 'Y',
    'term-fifteen': 'N',
  },
  'rider-options': {
    'memorial-seven-day': 'N',
    'memorial-forty-day': 'N',
    'memorial-one-year': 'N',
  },
  'double-accident-benefit': 'N',
  'life-assured-identification': {
    'first-names': null,
    surname: null,
    'idpassport-number': null,
    title: null,
    gender: null,
    'date-of-birth': null,
    'marital-status': null,
    ghanaian: null,
    'other-nationality': null,
    'nia-ghana-card': null,
    passport: null,
    'voter-id': null,
    dvla: null,
    nhis: null,
    ssnit: null,
    'id-type': null,
  },
  'life-assured-contact-details': {
    'cell-phone': null,
    email: null,
  },
  'life-assured-postal-address': {
    addressee: null,
    'po-box-or-private-bag': null,
    town: null,
    region: null,
  },
  'life-assured-residential-address': {
    street: null,
    suburb: null,
  },
  'life-assured-digital-address': {
    'digital-address': null,
  },
  'life-assured-employment-details': {
    'employer-organisation': null,
    'employee-number': null,
    'basic-earnings': null,
    occupation: null,
  },
  'spouse-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    'nia-ghana-card': null,
    passport: null,
    'voter-id': null,
    dvla: null,
    nhis: null,
    ssnit: null,
    'id-type': null,
    gender: null,
    title: null,
    'marital-status': null,
  },
  'spouse-contact-details': {
    'cell-phone': null,
    'work-phone': null,
    'home-phone': null,
  },
  'spouse-employment-details': {
    'employer-organisation': null,
    'employee-number': null,
    occupation: null,
  },
  'spouse-funeral': null,
  'spouse-is-trustee': null,
  'additional-lives': [],
  'parent-details': [],
  'tp-lives-assured': [],
  'trustee-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    'nia-ghana-card': null,
    passport: null,
    'voter-id': null,
    dvla: null,
    nhis: null,
    ssnit: null,
    'id-type': null,
    gender: null,
    title: null,
    'marital-status': null,
    relationship: null,
  },
  'trustee-contact-details': {
    'cell-phone': null,
    'work-phone': null,
    'home-phone': null,
  },
  'beneficiary-details': [],
  'existing-policies': {
    'existing-coverage': null,
    'application-replaces-existing': null,
  },
  'existing-policy-details': [
    { 'company-name': null, 'existing-contract-id': null, 'sum-assured': null },
    { 'company-name': null, 'existing-contract-id': null, 'sum-assured': null },
    { 'company-name': null, 'existing-contract-id': null, 'sum-assured': null },
  ],
  'life-assured-general-habits': {
    'planning-other-insurance': null,
    'planning-other-insurance-details': null,
    'other-assurance-past12-months': null,
    'other-assurance-past12-months-details': null,
    'cover-exceeds-one-hundred-thousand': null,
    'average-monthly-gross-income': null,
    'total-existing-assurance-cover-in-force-on-your-life': null,
    'full-reasons-for-effecting-this-additional-cover': null,
    'risky-occupation-hobbies': null,
    'risky-occupation-hobbies-details': null,
    'refused-application-or-increased-premium': null,
    'refused-application-or-increased-premium-details': null,
    'insolvency-issue': null,
    'insolvency-issue-details': null,
    'occupation-not-clerical': null,
    'occupation-not-clerical-details': null,
    smoker: null,
    'non-smoker': null,
    'never-smoked': null,
    'years-smoking': null,
    'years-not-smoking': null,
    'cigarettes-per-day': null,
    'cigars-per-day': null,
    pipe: null,
    'medical-advice-stop-smoking': null,
    'medical-advice-reduce-drinking': null,
    'excessive-drinking': null,
    'excessive-drinking-past': null,
  },
  'life-assured-health-details': {
    'surgery-last-five-years': null,
    'medical-tests-last-five-years': null,
    disability: null,
    'assurance-risk': null,
    pregnant: null,
    'family-history-of-illness': null,
    'family-history-of-illness-details': null,
    'close-family-early-death': null,
    'height-cm': null,
    'mass-weight-in-kg': null,
  },
  'life-assured-medical-details': {
    'chest-pain': null,
    'high-blood-pressure': null,
    'respiratory-condition': null,
    'digestive-condition': null,
    'urinary-condition': null,
    'anxiety-epilepsy': null,
    diabetes: null,
    'cancer-or-tumors': null,
    'arthritis-osteoporosis': null,
    aids: null,
    'sexually-transmitted-disease': null,
    'taking-medication': null,
  },
  'medical-attendant-details': {
    'medical-institution': null,
    'hospital-phone': null,
    'doctor-first-names': null,
    'doctor-surname': null,
    'doctor-cell-phone': null,
    'contact-doctor': null,
  },
  'health-concerns': [],
  'payment-method-selection': {
    'debit-order': null,
    'stop-order': null,
  },
  'payment-start-date': null,
  'payment-frequency': {
    monthly: null,
    annual: null,
    'bi-annual': null,
    quarterly: null,
  },
  'payer-person': {
    myself: null,
    'my-spouse': null,
  },
  'payer-person-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    'id-type': null,
  },
  'payment-bank-details': {
    'account-holder-name': null,
    'account-type': null,
    'account-entity-name': null,
    'account-branch-name': null,
    'account-number': null,
  },
  'payment-employment-details': {
    'employer-organisation': null,
    'employee-number': null,
  },
  'forces-pay-office-details': {
    'policy-name': 'Executive Plus Revised',
    'company-name': null,
    'branch-name': null,
    date: null,
    'representative-name': null,
    'telephone-number': null,
    'ecowas-id-number': null,
    'svc-number': null,
    'armed-forces-rank': null,
    unit: null,
  },
  'payer-signature': null,
  documents: {
    'id-document': [],
    'service-certificate-document': [],
  },
  'acceptance-signature': null,
  'application-acceptance-date': null,
  'application-accepted': null,
}
